<div class="sb-body" #scrollBody>
  <div *ngFor="let row of rows; trackBy: trackByRow" class="sb-row" [ngClass]="'sb-' + row.sender">
    <ng-container *ngIf="row.sender !== 'system'">
      <div class="sb-bubble" [ngClass]="row.sender === 'incoming' ? 'sb-bubble-in' : 'sb-bubble-out'">
        <p class="sb-text">{{ row.text }}</p>
      </div>
      <span class="sb-time">{{ row.time }}</span>
    </ng-container>
    <span *ngIf="row.sender === 'system'" class="sb-system">{{ row.text }}</span>
  </div>

  <div *ngIf="isTyping" class="sb-row sb-incoming">
    <div class="sb-bubble sb-bubble-in sb-typing" role="status" aria-label="Assistant is typing">
      <span></span><span></span><span></span>
    </div>
  </div>
</div>

<div class="sb-tray" *ngIf="chips.length || showUniversalChips">
  <div class="sb-chips" *ngIf="chips.length">
    <button type="button" class="sb-chip" *ngFor="let chip of chips" [disabled]="isBusy" (click)="sendChip(chip)">
      {{ chip.label }}
    </button>
  </div>

  <div class="sb-actions" *ngIf="showUniversalChips">
    <button type="button" class="sb-action" [class.sb-highlight]="highlightEscalation" [disabled]="isBusy" (click)="askTicket()">
      Create ticket
    </button>
    <button type="button" class="sb-action" [class.sb-highlight]="highlightEscalation" [disabled]="isBusy" (click)="askHuman()">
      Talk to human
    </button>
    <button type="button" class="sb-action" [disabled]="isBusy" (click)="askBack()">Back</button>
    <button type="button" class="sb-action" [disabled]="isBusy" (click)="askMenu()">Menu</button>
  </div>
</div>

<div class="sb-footer" *ngIf="showInput">
  <form class="sb-input-wrap" (submit)="sendText($event)">
    <input
      type="text"
      class="sb-input"
      name="botMessage"
      autocomplete="off"
      maxlength="500"
      [(ngModel)]="draft"
      [placeholder]="placeholder"
      [disabled]="isBusy" />
    <button type="submit" class="sb-send" [disabled]="isBusy || !draft.trim()" title="Send message" aria-label="Send message">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="22" y1="2" x2="11" y2="13"></line>
        <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
      </svg>
    </button>
  </form>
</div>